<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
    <span style="font-size:30px;font-weight:bold;">MOA未安装或版本不是最新</span><br><br>
    <span style="font-size:28px;font-weight:bold;">一、背景</span><br><br>
    <div style="background:#FFE4E1;width:100%;height:30px"><span><p>根据公司安全规定，未安装安全管理客户端（MOA），会被限制访问办公系统。</p></span></div>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当前公司有几万员工，人员变动频繁，存在几万台个人终端和便携式电子设备，缺乏对入网终端统一的管理。我们无法得知究竟有多少终端连入我们的网络，无法对每台
    接入网络的终端做认证，终端健康状态难以掌控。这给公司的IT安全带来很大风险，当出现类似于WannaCry勒索病毒时，我们无法快速得知哪些机器存在风险，也无法快速禁
    止被感染或有风险的机器接入网络。基于此，我们希望做一个统一的终端安全管理系统，做到安全可视化，对设备做统一的认证和管控，提升IT安全。<br>
    <span style="font-size:28px;font-weight:bold;">二、自查方法</span><br><br>
    <div style="background:#b3fff2;width:100%;height:30px"><span><p>如果是「请检查当前计算机MOA是否安装或MOA版本是否最新」 拦截提示，如下：</p></span></div>
    <p><img src="../assets/moaUninstall/moaUninstall_pic01.png" width=540px height=360px ></p>
    <p>1、请确认是否已安装MOA。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;如未安装，请参照MOA 安装指导：美团安全管理客户端（MOA）安装
    (<span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/moaInstallForWin')">Windows操作系统安装MOA</span>，
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/moaInstallForMac')">macOS操作系统安装MOA</span>)
    </p>
    <p>2、若已安装，请确认是否是最新版MOA。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;查看MOA版本方式：MOA版本查看（<span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/moaVersionView')">MOA版本查看</span>）。
    <p style="color:red">注意：因MOA部分旧版本不支持自动更新升级，在查看版本时获取不到最新版信息，MOA当前最新版本为：</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MAC 上MOA最新版本：【1.3.1.0 】（要求macOS操作系统版本 > 10.11）</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Windows上MOA最新版本： 【1.3.0.0 】（要求 Windows 7及以上操作系统版本）</p>
    3、安装时若遇到问题，请参考（
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/macOS_FAQ')">macOS FAQ</span>，
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/windows_FAQ')">windows FAQ</span>，
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/other_FAQ')">其他 FAQ</span>）或联系6000工作台协助解决。 <br>
    <p>若以上没有解决您的问题，请联系6000帮助台进行协助解决</p>
    <div style="background:#b3fff2;width:100%;height:30px"><span><p>如果是「您已被限制访问办公系统，请及时安装MOA/DLP产品」拦截提示，如下：</p></span></div>
    <p><img src="../assets/moaUninstall/moaUninstall_pic02.png" width=740px height=500px ></p>
    <p>1、跳出该提示说明您本地电脑未安装DLP或MOA产品，请按照拦截提示指导移步IT门户(
    <a data-auto_update="0" data-pageid="" href="https://itportal.sankuai.com/" style="color:#1890ff" class="ct-link" target="_blank" rel="noopener">https://itportal.sankuai.com/</a>
    )下载安装。</p>
    <p>2、若您本机已经安装了DLP和MOA，仍然跳出该提示，可能是您有多台机器用于过办公，另外机器上未安装DLP，请在另一台用于办公电脑上也安装运行DLP。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;可通过：https://report-mon.sankuai.com/report/api/check_status?mis_id=您的mis号 排查，DLP安装状态是否是“Y“。</p>
    <p><img src="../assets/moaUninstall/moaUninstall_pic03.png" width=1040px height=100px ></p>
    <p>若以上没有解决您的问题，请联系6000帮助台进行协助解决</p>

    <br>
    <span style="font-size:28px;font-weight:bold;">三、常见问题</span><br><br>
    <div style="background:#e5f5c9;width:100%;height:30px">申请临时白名单，仅有4小时有效期。<span style="color:red">若因特殊原因，需要较长时间，请联系6000。</span></div>
    <span style="color: rgb(29, 120, 205)">Q：我有紧急的事情需要访问线上系统，但是暂时无法安装MOA，怎么办？</span><br>
    A：可以点击【
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/whiteApply')">临时白名单申请地址</span>
    】，申请临时白名单。<span style="color: rgb(240, 94, 80)">有效期4小时，最多申请3次。</span>
    <br><br>
    <span style="color: rgb(29, 120, 205)">Q：我已经安装了MOA，为什么还是无法访问办公系统？</span><br>
    <p style="text-align: start;">A：请确认安装MOA后，是否已打开MOA界面根据提示使用大象扫码登录完成注册工作。</p>
    <p style="text-align: start;margin-left: 20px;">查看MOA是否安装：<span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/verifyMoaIsInstall')">如何判断MOA是否已经安装</span>（确定安装5分钟后，数据同步完成）。</p>
    <p style="text-align: start;margin-left: 20px;">如还有问题可联系6000协助您解决。</p><br>
    <p><span style="color: rgb(0, 0, 0)">为什么安装杀毒软件还要安装MOA？</span></p>
    <p><span style="color: rgb(0, 0, 0)">A：杀毒软件主要用于终端病毒和恶意软件的查杀。MOA是公司终端设备统一认证和管控的客户端，主要用于检测员工PC 终端的安全状态以及辅助员工网络接入，对员工业务操作不会影响，不会收集员工个人隐私信息。</span></p>
    <br>
    <p><span style="color: rgb(29, 120, 205)">Q: 怎样区分我的电脑是否需要安装MOA？</span></p>
    <p><span style="color: rgb(0, 0, 0)">A：符合以下任意一个条件的电脑都需要安装，无论是私人电脑，还是公司配发的电脑。若有多台，均需安装MOA。</span></p>
    <p><span style="color: rgb(0, 0, 0)">&nbsp;&nbsp;&nbsp;&nbsp;1、用于办公用途的电脑，办公用途包括但不限于:</span></p>
    <ul style="margin-left:40px">
      <li><p>使用浏览器登录使用任何公司web系统，包括但不限于web邮件、sankuai门户、HR平台等</p></li>
      <li><p>使用outlook、apple mail等邮件客户端软件收发邮件</p></li>
      <li><p>使用git等软件连接代码仓库进行开发工作</p></li>
      <li><p>直接登录或使用跳板机登录公司服务器</p></li>
      <li><p>存储公司资料的机器</p></li>
      <li><p>其它</p></li>
    </ul>
    <p style="text-align: start;">&nbsp;&nbsp;&nbsp;&nbsp;2、需要接入公司网络</p>
    <ul style="margin-left:40px">
       <li><p>通过有线连接公司网络</p></li>
       <li><p>通过无线连接公司网络</p></li>
    </ul>
    <p><span style="color: rgb(29, 120, 205)">Q：MOA会做什么事情，会监控我的电脑吗？</span></p>
    <p style="text-align: start;">A：<span style="color: rgb(0, 0, 0)">MOA是公司终端设备统一认证和管控的客户端，主要用于检测员工PC 终端的安全状态以及辅助员工网络接入，对员工业务操作不会影响。</span><strong><span style="color: rgb(240, 94, 80)">请大家放心，MOA不会监控员工操作电脑行为、聊天记录、隐私数据等。</span></strong></p>
    </div>
  </div>
</template>

<script>
  import store from '../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {

      },
      kmUrl(URL){
        window.open(URL);
      },
      routerUrl(URL){
        this.$router.push(URL)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }

          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:'',
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// moaUninstall.vue?60b37614